import React from 'react'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'

const withMetaKey = Component => {
	const Wrapper = props => {
		const { metaData } = props
		const key = metaData?.metaKey || 'none'

		return <Component {...props} key={key} />
	}

	Wrapper.propTypes = {
		metaData: PropTypes.instanceOf(PageMetaData),
	}

	return Wrapper
}

export default withMetaKey
